const Contact = Object.freeze({
	Id: 'id',
	FirstName: 'firstName',
	LastName: 'lastName',
	Companies: 'companies',
	Image: 'image',
	EmailWork: 'emailWork',
	EmailPersonal: 'emailPersonal',
	EmailOther: 'emailOther',
	// ContactTypes: 'contactTypes',
	ContactPosition: 'contactPosition',
	PhoneWork: 'phoneWork',
	PhoneMobile: 'phoneMobile',
	PhoneOther: 'phoneOther',
	Note: 'note',
	AddressWork: 'addressWork',
	AddressHome: 'addressHome',
	AddressOther: 'addressOther',
	Languages: 'languages',
	VFileId: 'vFileId',
});

export { Contact };
